import { message as antMessage, notification } from 'antd';
import { sendCloudwatchRUMError } from '$src/utils/cloudwatchRUM';

const error = (message, technicalDetails) => {
  console.error(message, technicalDetails);
  sendCloudwatchRUMError(message, technicalDetails);
};
const success = (message) => {
  antMessage.success(message, 2);
};
const warn = (message) => {
  antMessage.warn(message, 2);
};
const close = () => {
  notification.destroy();
};

export const Notify = { error, success, warn, close };
